import React from 'react';
import Image from 'react-bootstrap/Image';
import { Card, Row, Col } from 'react-bootstrap';
import img from '../img/New Pics/ERP-Software-vritti-1.png';
import img1 from '../img/New Pics/With Catus-LMS.jpg';
import img2 from '../img/Catus 4.jpg';
import img3 from '../img/Catus 1.jpg';
import img4 from '../img/tech2.png';
import img5 from '../img/Accounting.jpg';
import { motion } from 'framer-motion';
import "./About.css";

function CatusLMS() {
  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 1 } },
  };

  return (
    <>
      <Image className="fade-in responsive-img" src={img} height={500} width="100%" fluid />
    <div className='container mt-4'>
      <motion.h1
        initial="hidden"
        animate="visible"
        variants={fadeInUp}
        className='mt-5 pt-4 text-danger'
      >
        Logistics Software
      </motion.h1>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
      >
        {/* <Image className='my-2' src={img} height={500} fluid /> */}
      </motion.div>

      {/* Paragraphs with fade-up animation */}
      {[
        `We, Catus Technologies is a fast growing Software Development Company that offers Catus LMS (Logistics Management Software). CATUS Software is designed to gives you a competitive advantage and meet your requirements of activities used in the logistics and freight forwarding industries. CATUS is the effective solution to optimize your business with no room of human mistakes. It helps to increase productivity and generate better profits. Catus is multi-user software and can operate from different location by using a centralized server. It controls your complete business cycle. CATUS provides an extremely unmatched software solution to Logistics and Freight forwarding service provider industries, It includes complete operational and financial accounting.`,
        `CATUS is integrated software solution to manage all business activities that associated with Operational and Financial. It provides a document management with their attachments to shipments. Main purpose of CATUS software is to provide strategic services to customers, along with a powerful management of Information Exchange Systems. We assured Catus serves its purpose, restricts you for doing lots of unnecessary double entries. CATUS helps you to imagine a successful business model that determines how well your business grows. It brings your business to new heights of integration. It allows you to be access your business from almost anywhere via computer.`,
        `You will be probably shocked to see how many hours you was wasting doing work in your existing environment. We pride on our support services which are second to none and the reason that many of our customers either choose us in the first place, or switched to us subsequently.`,
      ].map((text, index) => (
        <motion.p className='fs-6 text-justify text-justify'
          key={index}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          {text}
        </motion.p>
      ))}

      <motion.h4
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInUp}
      >
        Apart from boosting productivity, CATUS can also enhance your business in several other aspects such as:
      </motion.h4>

      <motion.ul
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.08,
            },
          },
        }}
      >
        {[
          'Saves Money and Time, Reduce Hassles and Feel free your staff from spreadsheet data retrieval.',
          'Increasing the flexibility of your business and also keeps track of progress in your business.',
          'Easily maintained and Put you at a competitive advantage compared in your business sector.',
          'Increasing the value of your company.',
          'Improving the overall quality of your business.',
          'Improves sales and service. The way your customers experience your business is very important.',
          'Conrol your staff Knowing who made what changes and when, instantly.',
          'Stop finding documents around your workplace.',
          'Provides real time environment.',
        ].map((item, index) => (
          <motion.li className='fs-6 text-justify'
            key={index}
            variants={fadeInUp}
          >
            {item}
          </motion.li>
        ))}
      </motion.ul>

      <motion.p className='fs-6 text-justify' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        Catus Software is a user-friendly application which gives a helping hand to your organisation to manage data, resources, performance, and also manages all the internal task and communication for fruitful result. Its screens are designed to reduce the work load of the user and to allow the company to reduce costs.
      </motion.p>
      <div className='text-center'><Image className="my-5 fade-in" src={img1} height={400} fluid /></div>

      {/* Section: AIR EXPORT LOGISTICS SOFTWARE */}
      <motion.h4 className='text-danger' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        AIR EXPORT LOGISTICS SOFTWARE
      </motion.h4>
      <motion.p className='fs-6 text-justify' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        CATUS Air Export Logistics Software streamline your business, increase your productivity and generate bigger profits. Air Export Logistics Software Module is designed to manage Jobs, Master and House Airway Bill. The system generates all outputs required for completing the transaction.
      </motion.p>
      <motion.p className='fs-6 text-justify' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        CATUS Logistics software can digitalised your Logistics company and help you to grow in every part of your business. CATUS Logistics software is suitable for IATA Agents, Consolidators, Logistics Indtries, Freight Forwarding Agents, NVOCC, Third Party Logistics Providers and Trucking Industries,
      </motion.p>
      <motion.p className='fs-6 text-justify' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        CATUS is designed to allow quotations quickly and effectively with a minimum data. From the time of a quotation, until it is invoiced and converterd into the sales. All variables for a shipment are only entered once. In this way, an absolute minimum of information is recorded for each transaction, errors reduced, and productivity maximized.
      </motion.p>
      <motion.p className='fs-6 text-justify' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        All related shipment details such as Shipper, Consignee, Shipper Invoice, Commodity Details, Packing Details, Shipment terms, Origin and Destination, ports and airports, carrier, container, vessel and voyage, booking details, etc., are entered as available.
      </motion.p>

      <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
        <Card className='my-5 animated-card' border="primary">
          <Card.Body className='fs-6 text-justify'><strong>Key Features</strong></Card.Body>
          <hr />
          <Card.Body>
            <Row>
              <Col md={4}><ul>
                <li className='fs-6 text-justify'>Create Quotation</li>
                <li className='fs-6 text-justify'>Job Folder Maintenance</li>
                <li className='fs-6 text-justify'>Master Airwaybill Entry / Printing</li>
                <li className='fs-6 text-justify'>Shipper Invoice/Shipping Bill</li>
                <li className='fs-6 text-justify'>Merchandise Packing Details</li>
                <li className='fs-6 text-justify'>House Airwaybill Consolidation Printing</li>
                <li className='fs-6 text-justify'>Step by Step Shipment Movement</li>
                <li className='fs-6 text-justify'>Transportation Details</li>
                <li className='fs-6 text-justify'>Acknowledgement Note</li>
                <li className='fs-6 text-justify'>Document Despatch Details</li>

              </ul></Col>

              <Col md={3}>
                <img
                  src={img4}
                  alt="Features Illustration"
                  style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                />
              </Col>
              <Col md={4} className="d-flex align-items-center justify-content-center p-0">
                <ul>

                  <li className='fs-6 text-justify'>Cargo Manifest/COC Entry and Printing</li>
                  <li className='fs-6 text-justify'>Master Airwaybill Register</li>
                  <li className='fs-6 text-justify'>DSR (For a Period)</li>
                  <li className='fs-6 text-justify'>Job Costing (On a Single Click)</li>
                  <li className='fs-6 text-justify'>Job Register Datewise/Partywise</li>
                  <li className='fs-6 text-justify'>House Airwaybill Register</li>
                  <li className='fs-6 text-justify'>Spot Rate</li>
                  <li className='fs-6 text-justify'>Cargo Sales Report (CSR)</li>
                  <li className='fs-6 text-justify'>And Many More…</li>
                </ul>

              </Col>
            </Row>

          </Card.Body>
        </Card>
      </motion.div>

      {/* Section: SEA EXPORT */}
      <motion.h4 className='text-danger' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        SEA EXPORT FREIGHT FORWARDING SOFTWARE
      </motion.h4>
      <motion.p className='fs-6 text-justify' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        Catus Ocean/Sea Export Logistics Software Module efficiently manages container shipments throughout the complete life-cycle.
      </motion.p>
      <motion.p className='fs-6 text-justify' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        Under the Sea Export Logistics Software module, You will able to manage whole process of your shipment from origin to destination via cargo ships. CATUS Ocean Sea Export Logistics Software provides you the most powerful and flexible tools to maximize your productivity and reduce costs with very less efforts. Our Advanced software ensure you, end-to-end functionality.
      </motion.p>

      <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
        <Card className='my-5 animated-card' border="primary">
          <Card.Body className='fs-6 text-justify'><strong>Key Features</strong></Card.Body>
          <hr />
          <Card.Body>
            <Row>
              <Col md={5}>
                <ul>
                  <li className='fs-6 text-justify'>Create Quotation for existing and new customers</li>
                  <li className='fs-6 text-justify'>Job Folder</li>
                  <li className='fs-6 text-justify'>Master Bill of Lading Entry/ Printing</li>
                  <li className='fs-6 text-justify'>Shipper Invoice /Shipping Bill Details</li>
                  <li className='fs-6 text-justify'>House Consolidation and Printing</li>
                  <li className='fs-6 text-justify'>Container Register</li>
                  <li className='fs-6 text-justify'>Vessel Register</li>
                  <li className='fs-6 text-justify'>Brokerages & Refunds</li>
                  <li className='fs-6 text-justify'>Events and Transportation Details</li>
                  <li className='fs-6 text-justify'>Acknowledgement Note</li>
                  <li className='fs-6 text-justify'>Document Despatch Details</li>

                </ul>
              </Col>
              <Col md={3} className="d-flex justify-content-center">
                <img
                  src={img2}
                  alt="Features Illustration"
                  style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                />
              </Col>
              <Col md={4} className="d-flex align-items-center justify-content-center mx-0 px-0">
                <ul>
                  <li className='fs-6 text-justify'>Shipment Status Report</li>
                  <li className='fs-6 text-justify'>Shipped On Board Certificate</li>
                  <li className='fs-6 text-justify'>Shipment Landing Certificate</li>
                  <li className='fs-6 text-justify'>Importer security Filing</li>
                  <li className='fs-6 text-justify'>Job Cover</li>
                  <li className='fs-6 text-justify'>Sales Report (For a Period)</li>
                  <li className='fs-6 text-justify'>Job Costing (On a Single Click)</li>
                  <li className='fs-6 text-justify'>Job Register Date wise/Party wise</li>
                  <li className='fs-6 text-justify'>Master Airwaybill Register</li>
                  <li className='fs-6 text-justify'>House Airwaybill Register</li>
                  <li className='fs-6 text-justify'>And Many More…</li>
                </ul>
              </Col>
            </Row>

          </Card.Body>
        </Card>
      </motion.div>

      {/* Section: IMPORT FREIGHT */}
      <motion.h4 className='text-danger' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        Import Freight Forwarding Software
      </motion.h4>
      {[...Array(4)].map((_, i) => (
        <motion.p className='fs-6 text-justify' key={i} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
          {[
            "Catus Technologies: Import Logistics Software provides complete air, ocean and road, import, export, domestic and trans-border, single shipment, consolidation and de-consolidation processing. All operations from Cargo handover at origin to destination. Our Air Import Logistics Software generates all outputs required for completing the transaction.",
            "Our powerful freight management software solution has been designed to help you manage global freight for sea, air and land movements. Our software has been developed with an in-depth understanding of the unique and complex needs of the freight industry; experience which led us to produce a system to simplify your daily tasks and reduce your administration costs.It has been designed to make your job easier and provide you with all the tools you will ever need to deliver freight via sea, air or land and includes direct integration for Customs Clearances without the need for 3rd party applications.",
            "Our freight software has been designed to make your job easier and provide you with all the tools you will ever need to deliver your movements in the most cost effective manner possible. All our products and solutions are backed up by a reliable support team delivered by experts specializing solely in the development of international freight management solutions.",
            "All our products and solutions are backed up by a reliable support team delivered by experts specializing solely in the development of international freight management solutions."
          ][i]}
        </motion.p>
      ))}

      <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
        <Card className='my-5 animated-card' border="primary">
          <Card.Body className='fs-6 text-justify'>Key Features:</Card.Body>
          <hr />
          <Card.Body>
            <Row>
              {/* Left Column - Feature List */}
              <Col md={4}>
                <ul>
                  <li className='fs-6 text-justify'>Quotation</li>
                  <li className='fs-6 text-justify'>Pre Alert - Register Incoming Shipment</li>
                  <li className='fs-6 text-justify'>Pre Alert - Generate for Consignee</li>
                  <li className='fs-6 text-justify'>Shipment Landed Details</li>
                  <li className='fs-6 text-justify'>Job Folder</li>
                  <li className='fs-6 text-justify'>Master Airwaybill Entry / Printing</li>
                  <li className='fs-6 text-justify'>Shipper Invoice / Shipping Bill Details</li>
                  <li className='fs-6 text-justify'>House Airwaybill Consolidation and Printing</li>
                  <li className='fs-6 text-justify'>Events and Transportation Details</li>
                  <li className='fs-6 text-justify'>Acknowledgement Note</li>

                </ul>
              </Col>

              {/* Right Column - Image */}
              <Col md={3} className="d-flex justify-content-center">
                <img
                  src={img3}
                  alt="Features Illustration"
                  style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                />
              </Col>
              <Col md={4} className="d-flex align-items-center justify-content-center">
                <ul>
                  <li className='fs-6 text-justify'>IGM Amendment Letter</li>
                  <li className='fs-6 text-justify'>Document Despath Details</li>
                  <li className='fs-6 text-justify'>DO Covering Letter</li>
                  <li className='fs-6 text-justify'>CAN Entry/Printing</li>
                  <li className='fs-6 text-justify'>Delivery Order (DO) Entry/Printing</li>
                  <li className='fs-6 text-justify'>Sales Report (For a Period)</li>
                  <li className='fs-6 text-justify'>Job Costing (On a Single Click)</li>
                  <li className='fs-6 text-justify'>Job Register Datewise</li>
                  <li className='fs-6 text-justify'>And Many More…</li>
                </ul>
              </Col>
            </Row>
          </Card.Body>
        </Card>

      </motion.div>

      {/* Section: FINANCIAL ACCOUNTING */}
      <motion.h4 className='text-danger' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        FINANCIAL ACCOUNTING LOGISTICS SOFTWARE
      </motion.h4>
      <motion.p className='fs-6 text-justify' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        CATUS is designed based on international accounting principles. It provides facility of multiple currency transactions, budgeting, credit control, partner receivables. View and analyze detailed shipment profitability. Our CATUS Logistics Software is tightly bound with operational and financial accounting modules. It is also very useful for the management level to understand the profitability of every job report on a single click.
      </motion.p>
      <motion.h5 initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        GST INTEGRATED LOGISTICS SOFTWARE
      </motion.h5>
      <motion.p className='fs-6 text-justify' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        Automated billing with GST calculations according to inter or intra state rate calculation.
      </motion.p>
      <motion.p className='fs-6 text-justify' initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
        <strong className='custom-orange'>E-Way & E-Invoice Ready Just In  One Click.</strong>
      </motion.p>

      
      <Card className='my-5 animated-card' border="primary">
        <Card.Body className='fs-6 text-justify'>
          <strong>
            Key Features of our Financial Accounting Software:

        </strong>
        </Card.Body>
        <hr />
        <Card.Body>
           <Row>
        <Col md={4}>
          <ul>
            <li className='fs-6 text-justify'>Raise Quotation and Invoice</li>
            <li className='fs-6 text-justify'>Raise Overseas Invoice</li>
            <li className='fs-6 text-justify'>Raise Miscellaneous Invoice Credit Note...</li>
            {/* <p className='fs-6 text-justify mx-4 my-0 py-0'></p> */}
            <li className='fs-6 text-justify'>Register Overseas Agent Invoice Credit Note</li>
            {/* <p className='fs-6 text-justify mx-4'></p> */}
            <li className='fs-6 text-justify'>Receipt/Payment/Contra Journal Voucher</li>
            {/* <p className='fs-6 text-justify mx-4'></p> */}
            <li className='fs-6 text-justify'>Accounts Ledger</li>
            <li className='fs-6 text-justify'>TDS Voucher and Reports</li>
            <li className='fs-6 text-justify'>Credit control module...</li>
            <li className='fs-6 text-justify'>Budgeting and forecast reports</li>
            <li className='fs-6 text-justify'>Expense Memo...</li>
            <li className='fs-6 text-justify'>Bank Reconciliation</li>  
            <li className='fs-6 text-justify'>Sub Ledger</li>
            <li className='fs-6 text-justify'>Sub Ledger Schedule...</li>          
          </ul>
        </Col>
        <Col md={4} className="d-flex justify-content-center">
          <img
            src={img5}
            alt="Features Illustration"
            style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
          />
        </Col>
        <Col md={4}>
        <ul>          
            <li className='fs-6 text-justify'>Books of Accounts</li>
            <li className='fs-6 text-justify'>Statement of Account</li>
            <li className='fs-6 text-justify'>Ageing Analysis</li>
            <li className='fs-6 text-justify'>Month wise Sales/Purchase Report</li>
            <li className='fs-6 text-justify'>Cash/Bank Balances</li>
            <li className='fs-6 text-justify'>GST Reports</li>
            <li className='fs-6 text-justify'>Job Costing</li>
            <li className='fs-6 text-justify'>Cargo Sales Report</li>
            <li className='fs-6 text-justify'>Trial Balance</li>
            <li className='fs-6 text-justify'>Profit and Loss</li>
            <li className='fs-6 text-justify'>Balance Sheet</li>
            <li className='fs-6 text-justify'>And Many More…</li>
        </ul>
        </Col>
      </Row>
        </Card.Body>
      </Card >
    </div>
    </>
  );
}

export default CatusLMS;
